<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-primary print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
    (openedChanged)="navOpened = $event">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center p-6 pb-0">
            <img
                class="hidden w-30 dark:flex"
                src="images/logo/logo-text.svg"
                alt="Logo image" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden">
        <!-- Navigation toggle -->
        <button
            type="button"
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')"
            [attr.aria-label]="'Toggle navigation'"
            matTooltip="Mostra/nascondi menu">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <!-- Logo (appears when navigation is closed) -->
        <div
            class="overflow-hidden transition-all duration-300 ease-in-out"
            [class.ml-2]="!navOpened"
            [class.max-w-32]="!navOpened"
            [class.opacity-100]="!navOpened"
            [class.max-w-0]="navOpened"
            [class.opacity-0]="navOpened"
            [class.ml-0]="navOpened">
            <img
                class="h-10 w-auto transition-transform duration-300 ease-in-out"
                [class.scale-100]="!navOpened"
                [class.scale-75]="navOpened"
                src="images/logo/logo.svg"
                alt="Logo" />
        </div>

        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 md:px-6 dark:bg-transparent print:hidden">
        <span class="text-secondary font-medium">
            Fitt &copy; {{ currentYear }}
        </span>
    </div>
</div>
